import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  getHeadingList,
  getHeadingListSuccess,
  getHeadingListFailure,
  createHeading,
  createHeadingSuccess,
  createHeadingFailure,
  viewHeading,
  viewHeadingSuccess,
  viewHeadingFailure,
  updateHeading,
  updateHeadingSuccess,
  updateHeadingFailure,
  changeheadingstatus,
  changeheadingstatussuccess,
  changeheadingstatusfailure
} from "../../actions";
import {
    GET_HEADING_LIST,
    GET_HEADING_LIST_SUCCESS,
    GET_HEADING_LIST_FAILURE, 
    CREATE_HEADING,
    CREATE_HEADING_SUCCESS,
    CREATE_HEADING_FAILURE,
    VIEW_HEADING_SUCCESS,
    VIEW_HEADING_FAILURE,
    VIEW_HEADING, 
    UPDATE_HEADING_SUCCESS,
    UPDATE_HEADING_FAILURE,
    UPDATE_HEADING,
    CHANGE_HEADING_STATUS,
    CHANGE_HEADING_STATUS_SUCCESS,
    CHANGE_HEADING_STATUS_FAILURE
} from "../../Actions/types";
import api from "../../../helper/api";

function* createHeadings(action) {
  try {
    // action?.payload?.form
    // if(action?.payload?.limit == 10) {
      // console.log("createHeadings action : ",action)

      const response = yield api.post(
        "/admin/heading/add-heading",
        action?.payload?.form,
        // {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //   },
        // }
      );
      if (response?.status === 200 && response?.data?.code === 200) {
        toast.success(response?.data?.message);
  
        yield call(action?.payload?.callback, response?.data?.data);
        yield put(
          createHeadingSuccess({ createHeading: response?.data?.data })
        );
      } else if (response?.status === 200 && response?.data?.code !== 200) {
        toast.error(response?.data?.message);
      }
    // }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(createHeadingFailure({ createHeadingError: e }));
  }
}

function* updateHeadingStatus(action) {
  try {
    const response = yield api.put(
      `admin/heading/change-status/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        changeheadingstatussuccess({
          changeheadingstatus: response?.data?.data,
        })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(changeheadingstatusfailure({ changeheadingstatusError: e }));
  }
}

function* updateHeadings(action) {
  const form = {
    name: action?.payload?.form?.name,
    order: action?.payload?.form?.order, 
  };
  try {
    // if(action?.payload?.form?.password == undefined) {
    const response = yield api.put(
      `/admin/heading/edit-heading/${action?.payload?.form?.id}`,
      form,
      // {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //   },
      // }
    );
   
    if (response?.status === 200 && response?.data?.code === 200) {
      toast.success(response?.data?.message);

      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        updateHeadingSuccess({ updateHeading: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    // }
  }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(updateHeadingFailure({ updateHeadingError: e }));
  }
  
}

function* viewHeadings(action) {
  try {
    const response = yield api.get(
      `/admin/heading/view-heading/${action?.payload?.form?.id}`
    );
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(
        viewHeadingSuccess({ viewHeading: response?.data?.data })
      );
    } else if (response?.status === 200 && response?.data?.code !== 200) {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    toast.error(e?.response?.data?.message);
    yield put(viewHeadingFailure({ viewHeadingError: e }));
  }
}

function* headingList(action) {
  const form = {
    orderBy: action?.payload?.form?.orderBy,
    order: action?.payload?.form?.order,
    limit: action?.payload?.form?.limit,
    page: action?.payload?.form?.page,
    search: action?.payload?.form?.search,
  };
  try {
    // if(action?.payload?.form?.order !== 1) { 
    //   {
    const response = yield api.post(
      `/admin/heading/heading-listing`,
      form
    );
    if (response?.status === 200) {
      // console.log(action,"action?.payload")
      yield call(action?.payload?.callback, response?.data);
      yield put(
        getHeadingListSuccess({
            getHeadingList: response?.data?.data,
        })
      );
    } else if (response?.status === 200) {
      toast.error(response?.data?.message);
    // }
    // }
  }
  } catch (e) {
    // toast.error(e?.response?.data?.message);
    yield put(getHeadingListFailure({ viewHeadingError: e }));
  }
} 

 
function* getheadingStatusWatcher() {
  yield takeLatest(CHANGE_HEADING_STATUS, updateHeadingStatus);
}


function* getheadingListWatcher() {
  yield takeLatest(GET_HEADING_LIST, headingList);
}

function* createHeadingWatcher() {
  yield takeLatest(CREATE_HEADING, createHeadings);
}

function* updateHeadingWatcher() {
  yield takeLatest(UPDATE_HEADING, updateHeadings);
}

function* viewHeadingWatcher() {
  yield takeLatest(VIEW_HEADING, viewHeadings);
}

export default function* headingManagementSaga() {
  yield all([
    getheadingListWatcher(),
    createHeadingWatcher(),
    updateHeadingWatcher(),
    viewHeadingWatcher(),
    getheadingStatusWatcher()
  ]);
}
